import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { FormatoRutPipe } from 'src/app/Services/Utils/Pipes/format-rut.pipe';
import { setLocalStorage } from 'npx-arc-ui/utils';
import { passwordValidator } from 'src/app/Services/Utils/Validators/password.validator';
import { rutValidator } from 'src/app/Services/Utils/Validators/rut.validator';
import Storage from 'src/app/Models/Base/storage';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-register-erp',
  templateUrl: './register-erp.component.html',
  styleUrls: ['./register-erp.component.scss'],
  standalone: true,
  providers: [FormatoRutPipe],
  imports: [
    MatStepperModule
    , MatInputModule
    , ReactiveFormsModule
    , MatFormFieldModule
    , MatIconModule
    , RouterModule
    , CommonModule
  ]
})
export class RegisterErpComponent {
  @ViewChild(MatStepper) stepper!: MatStepper;
  hide: boolean = true;
  firstFormGroup: FormGroup = new FormGroup({
    legalCode: new FormControl('', [Validators.required, rutValidator]),
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [passwordValidator]),
  });
  secondFormGroup: FormGroup = new FormGroup({
    userErp: new FormControl('', [Validators.required]),
    passwordErp: new FormControl('', [Validators.required]),
    idCliente: new FormControl('', [Validators.required]),
  });
  message: string = 'Validación de cuenta, por favor espere';
  
  constructor(
    public appState: AppStateService,
    private legalCodePipeAux: FormatoRutPipe 
  ) { 
    this.firstFormGroup.markAllAsTouched();
  }

  onChange({value}: any){
    !!String(value).length && this.firstFormGroup.get('legalCode')?.setValue(this.legalCodePipeAux.transform(value))
  }

  onNext(){
    this.appState.loading =true;
    if(this.stepper.selectedIndex === 0){
      this.appState.AccountService
      .GetCheckAccount(this.firstFormGroup.value)
      .pipe(
        tap(({success, message}) =>{
          this.appState.loading=!true;
        if(success){
          this.stepper.next()
        }
        else{
          this.appState.showMiniMessage(message || 'Ocurrio un error interno', 'error')
        }
      }),
      catchError(err =>{
        this.appState.loading=!true;
        this.appState.showMiniMessage('Ocurrio un error interno', 'error')
        return EMPTY
      }))
      .subscribe();
    }
    else{
      this.appState.AccountService
      .PostCreateJumpAccount({...this.firstFormGroup.value ,...this.secondFormGroup.value})
      .pipe(
        tap(({success, message, token}) =>{
        if(success){
          const {email} = this.firstFormGroup.value;
          setLocalStorage(Storage.TOKEN, token);
          setLocalStorage(Storage.EMAIL, email);
          this.appState.onPostLogin();
        }
        else{
          this.appState.loading=!true;
          this.appState.showMiniMessage(message || 'Ocurrio un error interno', 'error')
        }
      }),
      catchError(err =>{
        this.appState.loading=!true;
        this.appState.showMiniMessage('Ocurrio un error interno', 'error')
        return EMPTY
      }))
      .subscribe();
    }
  }

  hasError(index: number): boolean{
    if(this.firstFormGroup.get('password')?.hasError('required')) return true;
    const { value } = this.firstFormGroup.get('password')!;
    const patterns = ['[a-z]+', '[A-Z]+', '[0-9]+', '[$&+,:;=?@#|<>.^*()%!-]'];
    switch (index) {
      case 1:
        return String(value).length < 10 || String(value).length > 50

      case 2:
        return !String(value).match(patterns[patterns.length - 1]) || false

      case 3:
        return !String(value).match(patterns[patterns.length - 2]) || false

      case 4:
        return !String(value).match(patterns[patterns.length - 3]) || false

      case 5:
        return !String(value).match(patterns[patterns.length - 4]) || false

      default:
        return false
    }
  }

  get invalid(){
    return this.stepper?.selectedIndex === 0 ? this.firstFormGroup.invalid : this.secondFormGroup.invalid || false
  }

  get passwordHint(): { text: string; statusClass: string; icon: string } {
    const val = this.firstFormGroup.get('password')?.value;
    if (!val) {
      return {
        text: 'Mínimo 10 caracteres, mayúscula, número y especial',
        statusClass: 'info',
        icon: 'info'
      };
    }
    if (this.hasError(1)) {
      return {
        text: 'Debe tener entre 10 y 50 caracteres',
        statusClass: 'error',
        icon: 'error'
      };
    }
    if (this.hasError(4)) {
      return {
        text: 'Falta al menos una letra mayúscula',
        statusClass: 'error',
        icon: 'error'
      };
    }
    if (this.hasError(5)) {
      return {
        text: 'Falta al menos una letra minúscula',
        statusClass: 'error',
        icon: 'error'
      };
    }
    if (this.hasError(3)) {
      return {
        text: 'Falta al menos un número',
        statusClass: 'error',
        icon: 'error'
      };
    }
    if (this.hasError(2)) {
      return {
        text: 'Falta al menos un carácter especial',
        statusClass: 'error',
        icon: 'error'
      };
    }
    return {
      text: 'Contraseña válida',
      statusClass: 'success',
      icon: 'check_circle'
    };
  }
}
